export default __webpack_public_path__ + "static/media/holidayon5.3a6e58bf.jpg";